function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2.72729,
  y: 5.45456,
  width: 21.8182,
  height: 15,
  stroke: "#FFFFFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7059 8.18182H27.2728V23.1818H5.45459V20.6818",
  stroke: "#FFFFFF"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.50004,
  cy: 10.2273,
  rx: 2.04545,
  ry: 2.04545,
  stroke: "#FFFFFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.72729 20.4545L8.18184 15L10.9091 17.0454L14.3182 12.9545L17.7273 15.6818L24.5455 10.2273",
  stroke: "#FFFFFF"
});

var SvgGaleries = function SvgGaleries(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGaleries, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/galeries.5866f0c8.svg";
export { ForwardRef as ReactComponent };